package com.flowyride.feature.planner.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.flowyride.core.domain.analysis.SpeedBand
import com.flowyride.core.map.routeColor
import com.flowyride.feature.planner.resources.Res
import com.flowyride.feature.planner.resources.speed_band_fast
import com.flowyride.feature.planner.resources.speed_band_road
import com.flowyride.feature.planner.resources.speed_band_slow
import com.flowyride.feature.planner.resources.speed_band_town
import com.flowyride.feature.planner.resources.speed_band_unknown
import com.flowyride.feature.planner.ui.formatDistance
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

/** Legend of the route colors, with the distance ridden in each band: "● ≤ 50 km/h 12 km  ● 80-90 98 km". */
@Composable
internal fun SpeedLegend(distanceByBand: Map<SpeedBand, Double>, modifier: Modifier = Modifier) {
    FlowRow(modifier, horizontalArrangement = Arrangement.spacedBy(12.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
        distanceByBand.forEach { (band, meters) ->
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                Box(Modifier.size(width = 16.dp, height = 5.dp).background(band.routeColor, RoundedCornerShape(2.dp)))
                Text(
                    "${stringResource(band.label)} · ${formatDistance(meters)}",
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
        }
    }
}

private val SpeedBand.label: StringResource
    get() = when (this) {
        SpeedBand.TOWN -> Res.string.speed_band_town
        SpeedBand.SLOW -> Res.string.speed_band_slow
        SpeedBand.ROAD -> Res.string.speed_band_road
        SpeedBand.FAST -> Res.string.speed_band_fast
        SpeedBand.UNKNOWN -> Res.string.speed_band_unknown
    }
